import { SystemFieldNames, SystemFieldGroups } from './systemFieldConstants'
import type { QField } from '~/features/questionnaire/types'
import type { SystemFieldDetails } from './systemFieldConstants'

const
  title = 'Expected germination time (days after planting)',
  description = 'This is used to build a schedule for the experiment.',
  schemaEntry: QField = {
    fieldName: SystemFieldNames.germinationDay,
    fieldType: 'NUMBER'
  },
  fieldDetails: SystemFieldDetails = {
    fieldName: SystemFieldNames.germinationDay,
    variableGroup: SystemFieldGroups.SCHEDULE,
    isRequired: false,
    title,
    description,
    schemaEntry
  }

export {
  fieldDetails
}
